/* eslint-disable react/prop-types */
import React from 'react';

import MakeModelTypeAheadGroup from '../../../../components/make-model/make-model-typeahead-group';
import { useMakeModelProvider } from '../../Providers/make-model-panel-provider';

const SelectMakeModelPanel = () => {
  const state = useMakeModelProvider();
  const { showChassis, requiresChassis } = state;

  return (
    <div className="grid-row grid-gap-4 flex-align-end">
      <MakeModelTypeAheadGroup
        state={state}
        showChassis={showChassis}
        requiresChassis={requiresChassis}
        fieldWrapperClassName="grid-col flex-1"
        labels={{
          bodyMake: 'Make',
          bodyModel: 'Model',
          chassisMake: 'Chassis make',
          chassisModel: 'Chassis model',
        }}
        placeholders={{
          bodyMake: 'Search make',
          bodyModel: 'Search model',
          chassisMake: 'Search chassis make',
          chassisModel: 'Search chassis model',
        }}
        preLoadHelpMessages={{
          bodyMake: 'Type to search for makes',
          bodyModel: 'Type to search for models',
          chassisMake: 'Type to search for chassis makes',
          chassisModel: 'Type to search for chassis models',
        }}
      />
    </div>
  );
};

export default SelectMakeModelPanel;
